/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Whitespace_LabelInputs */



/**
* | output |
* | --- |
* | "Whitespace" |
*
* @param {Style_Guide_Manager_Whitespace_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_whitespace_label = /** @type {((inputs?: Style_Guide_Manager_Whitespace_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Whitespace_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Espaces")
	if (locale === "de") return /** @type {LocalizedString} */ ("Leerraum")
	if (locale === "it") return /** @type {LocalizedString} */ ("Spazio bianco")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пространство")
	if (locale === "es") return /** @type {LocalizedString} */ ("Espacio en blanco")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("空格")
	if (locale === "ja") return /** @type {LocalizedString} */ ("空白")
	if (locale === "hi") return /** @type {LocalizedString} */ ("श्वेत रिक्ति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Espaço em branco")
	return /** @type {LocalizedString} */ ("Whitespace")
});